import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { summaryService, SummaryGenerateRequest } from '../services/summaryService';

export const useSummaryViewModel = (consultationId?: number) => {
  const queryClient = useQueryClient();

  const {
    data: summaries,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['summaries', consultationId],
    queryFn: () => summaryService.getList(consultationId),
    enabled: !!consultationId,
  });

  const generateMutation = useMutation({
    mutationFn: summaryService.generate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['summaries', consultationId] });
      if (consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', consultationId] });
      }
    },
  });

  const regenerateMutation = useMutation({
    mutationFn: summaryService.regenerate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['summaries', consultationId] });
      if (consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', consultationId] });
      }
    },
  });

  const deleteMutation = useMutation({
    mutationFn: summaryService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['summaries', consultationId] });
    },
  });

  return {
    summaries: summaries ?? [],
    isLoading,
    error,
    refetch,
    generateSummary: (data: SummaryGenerateRequest) => generateMutation.mutateAsync(data),
    isGenerating: generateMutation.isPending,
    regenerateSummary: regenerateMutation.mutate,
    isRegenerating: regenerateMutation.isPending,
    deleteSummary: deleteMutation.mutate,
    isDeleting: deleteMutation.isPending,
  };
};
